import i18n from '@/utils/i18n';
import React from 'react';
import { Skeleton, XStack, YStack } from '@usepepper/sprout-kit-ui';

const NAME_WIDTH = 148;
const META_WIDTH = 196;

export const OrderEntryMobileHeaderSkeleton: React.FC = () => (
  <XStack
    accessibilityLabel={i18n.t(
      'sales_portal.order_entry.mobile_header.a11y.loading',
    )}
    accessibilityState={{ busy: true }}
    alignItems="center"
    backgroundColor="$bgPrimaryDefault"
    borderBottomColor="$borderPrimary"
    borderBottomLeftRadius="$18"
    borderBottomRightRadius="$18"
    borderBottomWidth={1}
    borderLeftColor="$borderPrimary"
    borderLeftWidth={1}
    borderRightColor="$borderPrimary"
    borderRightWidth={1}
    gap="$12"
    paddingBottom="$16"
    paddingHorizontal="$16"
    paddingTop="$8"
    width="100%"
  >
    <Skeleton height="$40" variant="circle" width="$40" />
    <YStack gap="$4">
      <Skeleton height="$16" width={NAME_WIDTH} />
      <Skeleton height="$14" width={META_WIDTH} />
    </YStack>
  </XStack>
);
